import { Alert, Stack } from '@mui/material';
import { useOffline } from '../../offline/OfflineContext';

function fmtTime(iso) {
  if (!iso) return null;
  try {
    return new Date(iso).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
  } catch { return null; }
}

export default function OfflineBanner() {
  const ctx = useOffline();
  if (!ctx) return null;
  const { online, pending, errors, lastSyncAt } = ctx;
  const errorCount = errors ? errors.length : 0;
  if (online && pending === 0 && errorCount === 0) return null;

  const t = fmtTime(lastSyncAt);
  return (
    <Stack spacing={1} sx={{ px: 2, pt: 1 }}>
      {!online && (
        <Alert severity="warning">
          Offline{t ? ` – Stand von ${t} Uhr` : ''}
        </Alert>
      )}
      {pending > 0 && (
        <Alert severity="info">
          {pending} {pending === 1 ? 'Eintrag wird' : 'Einträge werden'} gesendet, sobald du online bist
        </Alert>
      )}
      {errorCount > 0 && (
        <Alert severity="error">
          {errorCount} {errorCount === 1 ? 'Eintrag konnte' : 'Einträge konnten'} nicht gesendet werden
        </Alert>
      )}
    </Stack>
  );
}
